/*
  GIFT SET — MONOGRAM, INCLUDED  (v2.4)

  The behaviour of the gift monogram Custom code block. It lives here
  rather than inside the block because a Custom Liquid setting cannot
  exceed 50kb, and because six gift sets sharing one cached file beats
  six product pages each carrying their own copy of it.

  IT CONTAINS NO LIQUID, deliberately, and the build refuses to write it
  if any is left in. Everything it needs is on the root element:
  data-form, data-variant, data-applies, data-max, data-quote-max,
  data-lp, data-chars. A .js asset is served as it is written, so
  anything that had to be rendered would force it to become a
  .js.liquid and be rendered again on every single request.
*/
(function () {
  "use strict";

  function init(root) {
    if (!root || root.getAttribute("data-cfg-ready")) return;
    root.setAttribute("data-cfg-ready", "1");
  var uid = root.id;
  var formId = root.getAttribute("data-form");
  var maxChars = parseInt(root.getAttribute("data-max"), 10) || 3;
  var quoteMax = parseInt(root.getAttribute("data-quote-max"), 10) || 0;
  var lpId = (root.getAttribute("data-lp") || "").trim();
  /*
    Membership in a string, not a regular expression. The permitted set
    includes \ | [ ] ( ) ? * . ^ $ and two non-ASCII glyphs; every one of
    those means something inside a character class, so a regex built from
    the same list needs escaping rules that are easy to get subtly wrong.
  */
  var ALLOWED = root.getAttribute("data-chars") || "";

  var text   = root.querySelector("[data-cfg-text]");
  var place  = root.querySelector("[data-cfg-place]");
  var pair   = root.querySelector("[data-cfg-pair]");
  var optout = root.querySelector("[data-cfg-optout]");
  var fields = root.querySelector("[data-cfg-fields]");
  var err    = root.querySelector("[data-cfg-err]");
  var sample = root.querySelector("[data-cfg-sample]");
  var extras = root.querySelectorAll('input[name^="properties["]:not([data-cfg-keep])');
  var variant = root.getAttribute("data-variant");
  var kinds  = root.querySelectorAll("[data-cfg-kind]");
  var fins   = root.querySelectorAll("[data-cfg-fin]");
  var finval = root.querySelector("[data-cfg-finval]");
  var segs   = root.querySelectorAll("[data-cfg-seg]");
  var segLabs = root.querySelectorAll("[data-cfg-seg-lab]");
  var lpRow  = root.querySelector("[data-cfg-lp]");
  var lab    = root.querySelector("[data-cfg-lab]");
  var inc    = root.querySelector("[data-cfg-inc]");
  var shadow = root.querySelector("[data-cfg-shadow]");
  var note = root.querySelector("[data-cfg-note]");
  var noteCount = root.querySelector("[data-cfg-note-count]");
  var noteMax = note ? (parseInt(note.getAttribute("maxlength"), 10) || 200) : 0;
  /* Line breaks become spaces: a property is one line on the slip. */
  function cleanNote(){
    if (!note) return;
    var v = note.value.replace(/[\r\n]+/g, " ");
    if (v !== note.value) note.value = v;
    if (noteCount) noteCount.textContent = note.value.length + " / " + noteMax;
  }
  /* An empty note is DISABLED at submit, so it never reaches the order as
     a blank "Gift note:" line. Re-enabled the moment anyone types. */
  function settleNote(){
    if (!note) return;
    cleanNote();
    note.disabled = !note.value.trim();
  }
  if (note){
    note.addEventListener("input", function(){ note.disabled = false; cleanNote(); });
    note.addEventListener("focus", function(){ note.disabled = false; });
  }
  var applies = root.getAttribute("data-applies");
  var sampleDefault = sample ? sample.textContent : "";
  var sampleGhost = sample ? (sample.getAttribute("opacity") || ".55") : ".55";

  function off(){ return optout.checked; }

  /* Which of the two presses is selected, and therefore how long the field
     is, whether a space is a character, what the property is called, and
     whether there is a surcharge. One question, asked in one place. */
  function isQuote(){
    if (quoteMax <= 0) return false;
    for (var i = 0; i < kinds.length; i++) if (kinds[i].checked) return kinds[i].value === "quote";
    return false;
  }
  function cap(){ return isQuote() ? quoteMax : maxChars; }
  function finish(){
    for (var i = 0; i < fins.length; i++) if (fins[i].checked) return fins[i].value;
    return finval ? finval.value : "";
  }
  /* The finish IS the variant — one $0 variant per finish — so picking a
     finish picks the line the monogram is added as. */
  function finVariant(){
    for (var i = 0; i < fins.length; i++)
      if (fins[i].checked) return fins[i].getAttribute("data-variant");
    return variant;
  }
  function hideErr(){ err.hidden = true; err.textContent = ""; }
  function showErr(m){ err.textContent = m; err.hidden = false; }

  /*
    Opting out DISABLES every property input rather than clearing them.
    Disabled controls are neither submitted nor validated, so one flag
    both drops `required` and keeps an empty Monogram off the order. It
    also means what was typed survives an untick and re-tick.
  */
  function sync(){
    var d = off();
    [].forEach.call(extras, function (el){ el.disabled = d; });
    [].forEach.call(segs, function (el){ el.hidden = d; });
    [].forEach.call(segLabs, function (el){ el.hidden = d; });
    fields.hidden = d;
    text.hidden = d;
    if (d) hideErr();
  }

  /*
    A space is a character a quote can hold and a monogram cannot: three
    initials with a space in them is a typo that would otherwise reach the
    bench as one. Runs of spaces collapse and a leading space is dropped,
    but a single trailing space is kept — without it you could not type the
    second word of a quote.

    The cap is cap(), not maxChars, so switching to a monogram with
    eighteen characters typed trims to three rather than sending the long
    one at the short price.
  */
  function clean(v){
    var up = v.toUpperCase(), lim = cap(), q = isQuote(), out = "";
    for (var i = 0; i < up.length && out.length < lim; i++){
      var c = up.charAt(i);
      if (c === " "){
        if (q && out.length && out.charAt(out.length - 1) !== " ") out += c;
        continue;
      }
      if (ALLOWED.indexOf(c) > -1) out += c;
    }
    return out;
  }

  /*
    THE PRESS IS ONE SIZE, so a quote is not shrunk to fit — it is set over
    two lines, broken at the space nearest the middle so the two read
    evenly. The atelier's own algorithm, character for character, because
    the drawing and the press must agree about where the break falls.
  */
  var LINE_EM = 1.45;
  function pressLines(str){
    if (!str) return [""];
    if (str.length <= 10 || str.indexOf(" ") === -1) return [str];
    var mid = str.length / 2, best = -1;
    for (var i = 0; i < str.length; i++)
      if (str.charAt(i) === " " &&
          (best === -1 || Math.abs(i - mid) < Math.abs(best - mid))) best = i;
    if (best === -1) return [str];
    return [str.slice(0, best), str.slice(best + 1)];
  }
  /* Two lines straddle the placement point rather than hanging below it. */
  function setSample(el, str){
    while (el.firstChild) el.removeChild(el.firstChild);
    var rows = pressLines(str), x = el.getAttribute("x");
    var top = -(rows.length - 1) * LINE_EM / 2;
    rows.forEach(function (line, i){
      var t = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
      t.setAttribute("x", x);
      t.setAttribute("dy", (i === 0 ? top : LINE_EM) + "em");
      t.textContent = line;
      el.appendChild(t);
    });
  }

  function paint(){
    if (!sample) return;
    var v = text.value.trim();
    setSample(sample, v || sampleDefault);
    sample.setAttribute("opacity", v ? ".85" : sampleGhost);
    var gold = /gold/i.test(finish());
    sample.setAttribute("fill", gold ? "url(#" + uid + "-foil)" : "currentColor");
    if (shadow){
      setSample(shadow, v || sampleDefault);
      shadow.setAttribute("display", gold ? "inline" : "none");
    }
  }

  /* Everything the choice of press changes, in one function, so the field,
     its label, its length, its property name and the surcharge row cannot
     end up describing two different presses. */
  function syncKind(){
    var q = isQuote();
    root.setAttribute("data-kind", q ? "quote" : "monogram");
    text.setAttribute("maxlength", String(cap()));
    text.setAttribute("name", "properties[" + (q ? "Quote" : "Monogram") + "]");
    var ph = text.getAttribute(q ? "data-ph-quote" : "data-ph-mono");
    if (ph != null) text.setAttribute("placeholder", ph);
    if (lab) lab.textContent = lab.getAttribute(q ? "data-quote" : "data-mono") || lab.textContent;
    if (lpRow) lpRow.hidden = !q;
    if (inc) inc.textContent = inc.getAttribute(q ? "data-quote" : "data-included") ||
                               inc.textContent;
    var c = clean(text.value);
    if (c !== text.value) text.value = c;
  }

  function syncFin(){
    if (finval) finval.value = finish();
  }

  optout.addEventListener("change", function(){ sync(); paint(); });
  [].forEach.call(kinds, function (r){
    r.addEventListener("change", function(){ syncKind(); hideErr(); paint(); });
  });
  [].forEach.call(fins, function (r){
    r.addEventListener("change", function(){ syncFin(); paint(); });
  });
  text.addEventListener("input", function(){
    var c = clean(this.value);
    if (c !== this.value) this.value = c;
    if (c) hideErr();
    paint();
  });
  syncKind(); syncFin(); sync(); paint();

  function newToken(){
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID().slice(0, 8);
    // Date.now alone collides for two adds inside one millisecond, which
    // two quick clicks manage.
    return (Date.now().toString(36) + Math.random().toString(36).slice(2, 6)).slice(-8);
  }

  /*
    The monogram line, added BEFORE the set, the same way the folio block
    adds its charge. Same quantity as the set: two sets, two presses.
  */
  function addMonogram(qty){
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var q = isQuote(), letters = text.value.trim();

    /* Built key by key rather than as a literal, because the property is
       called Quote on a quote and Monogram on a monogram — the atelier's
       convention, and the one the bench reads. */
    var props = {};
    props["For"] = applies;
    props[q ? "Quote" : "Monogram"] = letters;
    props["Placement"] = place.value;
    if (finval && finval.value) props["Finish"] = finval.value;
    props["_build"] = pair.value;
    props["_press"] = "Folio";

    var items = [{ id: Number(finVariant()), quantity: qty, properties: props }];

    /*
      THE SURCHARGE IS ITS OWN LINE, at the same quantity: two sets with
      quotes are two long presses. It carries `_build` so the cart groups
      it with the set, and deliberately NOT `For` — the bench makes a press
      job from any line carrying both, so a `For` here would be a second
      press for one pressing.
    */
    if (q && lpId){
      items.push({ id: Number(lpId), quantity: qty, properties: {
        "Charge for": applies,
        "Quote": letters,
        "_build": pair.value,
        "_surcharge": "Long press"
      }});
    }

    return fetch(base + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if (!r.ok) return r.json().then(function(j){
        throw new Error(j.description || "Could not add the monogram.");
      });
      return r.json();
    });
  }

  /*
    Capture phase on `document`, not on the form. At the target element
    capture and bubble listeners fire in registration order, so a capture
    listener on the form itself would not reliably beat the theme's own
    handler; on an ancestor it always does.

    `form.getAttribute("id")`, never `form.id`. A form's named controls
    override the element's own properties — every Shopify product form
    contains <input name="id"> for the variant, so `form.id` returns that
    INPUT. Same reason submit and requestSubmit are called off the
    prototype.

    This is the folio block's manoeuvre, unchanged in shape: stop the
    submit, add the monogram line, then let the form go on its way with a
    pass flag so this listener waves it through.
  */
  document.addEventListener("submit", function(e){
    var form = e.target;
    if (!form || form.getAttribute("id") !== formId) return;
    settleNote();

    if (form.getAttribute("data-cfg-pass")){
      form.removeAttribute("data-cfg-pass");
      return;
    }
    if (off()) return;

    if (!text.value.trim()){
      e.preventDefault(); e.stopImmediatePropagation();
      /* Named from the label, so the message cannot ask for initials under
         a field headed Quote. */
      var what = (lab ? lab.textContent : "initials").toLowerCase();
      showErr("Add the " + what + ", or choose to send it without a monogram.");
      text.focus();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    pair.value = newToken();
    var qty = parseInt(new FormData(form).get("quantity"), 10);
    if (!(qty > 0)) qty = 1;

    var submitter = e.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitter) submitter.setAttribute("aria-busy", "true");

    addMonogram(qty).then(function(){
      form.setAttribute("data-cfg-pass", "1");
      /*
        Deferred by a task, and it does not work without this. A form that
        has just fired a submit event stays locked against requestSubmit
        until the current task finishes, so calling it from the fetch's
        continuation is silently a no-op. Measured on the folio block.
      */
      setTimeout(function(){
        var RS = HTMLFormElement.prototype.requestSubmit;
        if (typeof RS === "function") RS.call(form, submitter);
        else HTMLFormElement.prototype.submit.call(form);
      }, 0);
    }).catch(function(ex){
      // The set is NOT added when the monogram line fails: a set in the
      // cart with initials the order will never show is the exact
      // problem this version exists to fix.
      showErr(ex.message || "Something went wrong. Please try again.");
    }).then(function(){
      if (submitter) submitter.removeAttribute("aria-busy");
    });
  }, true);
  }

  function scan(ctx) {
    var list = (ctx || document).querySelectorAll("[data-cfg]");
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(); });
  } else {
    scan();
  }

  /*
    The theme editor swaps a section's markup without re-running an
    external script, so a block that had just been edited would come back
    on screen with a dead monogram field. An inline script never had this
    problem because it was re-executed along with the markup; this one has
    to be told.
  */
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
})();